// src/components/EditAccount.js
import React, { useEffect, useState } from 'react';
import { auth, db, storage } from '../firebase';
import { doc, getDoc, updateDoc } from 'firebase/firestore';
import { ref, uploadBytes, getDownloadURL } from 'firebase/storage';
import { useNavigate } from 'react-router-dom';

function EditAccount() {
  const [userData, setUserData] = useState({ name: '', age: '', country: '', photoURL: '' });
  const [file, setFile] = useState(null);
  const [successMessage, setSuccessMessage] = useState('');
  const navigate = useNavigate();

  const fetchUserData = async () => {
    const docRef = doc(db, 'users', auth.currentUser.uid);
    const docSnap = await getDoc(docRef);
    if (docSnap.exists()) {
      setUserData(docSnap.data());
    }
  };

  useEffect(() => {
    fetchUserData();
  }, []);

  const handleChange = (e) => {
    setUserData({ ...userData, [e.target.name]: e.target.value });
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const docRef = doc(db, 'users', auth.currentUser.uid);

    try {
      let photoURL;
      if (file) {
        const storageRef = ref(storage, `profilePictures/${auth.currentUser.uid}`);
        await uploadBytes(storageRef, file);
        photoURL = await getDownloadURL(storageRef);
      }

      const updateData = {
        name: userData.name,
        age: userData.age,
        country: userData.country,
      };

      if (photoURL) {
        updateData.photoURL = photoURL;
      }

      // ✅ Only send whitelisted fields to Firestore
      await updateDoc(docRef, updateData);

      setSuccessMessage('✅ Profile updated!');
      setTimeout(() => navigate('/dashboard'), 1500);
    } catch (err) {
      console.error('❌ Error updating account:', err);
      alert('Failed to update account. Please try again.');
    }
  };

  return (
    <div className="max-w-md mx-auto mt-10">
      <h2 className="text-xl font-semibold mb-4">Edit Account Info</h2>

      {successMessage && (
        <div className="mb-4 p-2 bg-green-100 text-green-800 rounded">
          {successMessage}
        </div>
      )}

      <form onSubmit={handleSubmit} className="flex flex-col gap-4">
        <input
          name="name"
          placeholder="Name"
          value={userData.name}
          onChange={handleChange}
          className="p-2 border rounded"
        />
        <input
          name="age"
          placeholder="Age"
          value={userData.age}
          onChange={handleChange}
          className="p-2 border rounded"
        />
        <input
          name="country"
          placeholder="Country"
          value={userData.country}
          onChange={handleChange}
          className="p-2 border rounded"
        />
        <input type="file" onChange={handleFileChange} />
        {userData.photoURL && (
          <img
            src={userData.photoURL}
            alt="Profile Preview"
            className="w-24 h-24 rounded-full object-cover"
          />
        )}
        <button type="submit" className="bg-blue-500 text-white p-2 rounded">
          Save Changes
        </button>
        <button type="button" onClick={() => navigate('/dashboard')} className="underline text-sm">
          Cancel
        </button>
      </form>
    </div>
  );
}

export default EditAccount;
